import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  getReportStatus: 'idle',
  error: '',
  getReportData: {},
  getReportSubmitReport: {},
  getAllReportStatus: 'idle',
  getAllReportData: {},
  getIdiqReportData: {},
  getIdiqReportStatus: 'idle',
  getRoundStatus: 'idle',
  getRoundData: {},
  isReportUploaded: false,
  getIdiqLoginReport: {},
  getIdiqLoginStatus: 'idle',
};

export const submitReportContent = createAsyncThunk('reports/addReportContent', async initalContent => {
  let formData = new FormData();
  let accessToken = localStorage.getItem('accessToken');
  formData.append('Token', accessToken);
  formData.append('client_id', btoa(initalContent.client_id));
  formData.append('round', 1);
  formData.append('sourcecodearea', initalContent.report_content);
  formData.append('reportType', initalContent.report_type);
  let response = await axios.post('form/importreport', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

export const getReportContent = createAsyncThunk('reports/getReportContent', async initalContent => {
  let formData = new FormData();
  let accessToken = localStorage.getItem('accessToken');
  formData.append('Token', accessToken);
  formData.append('client_id', btoa(initalContent.client_id));
  formData.append('round', 1);
  formData.append('sourcecodearea', `${initalContent.report_content}`);
  formData.append('reportType', initalContent.report_type);
  let response = await axios.post('form/checkReportedName', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

export const getAllReport = createAsyncThunk('reports/getAllReports', async initialData => {
  let formData = new FormData();
  let accessToken = localStorage.getItem('accessToken');
  formData.append('Token', accessToken);
  formData.append('round', initialData.roundid);
  formData.append('client_id', btoa(initialData.clientId));
  if (initialData.round_year) {
    formData.append('round_year', initialData.round_year);
  }
  let response = await axios.post('form/getReportData', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

export const getIdiqReport = createAsyncThunk('report/getIdiqReport', async initalContent => {
  let formData = new FormData();
  let accessToken = localStorage.getItem('accessToken');
  formData.append('Token', accessToken);
  formData.append('client_id', btoa(initalContent.id));
  formData.append('docupload', initalContent.file);
  formData.append('provider_type', 'IdentityIQ');
  let response = await axios.post('form/getReportPdfToJson', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
      // return dataIdiqJson;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
  // return dataIdiqJson;
});

export const getIdiqReportLogin = createAsyncThunk('report/getIdiqReportLogin', async initalContent => {
  let formData = new FormData();
  let accessToken = localStorage.getItem('accessToken');
  formData.append('Token', accessToken);
  formData.append('client_id', btoa(initalContent.id));
  formData.append('round', 1);
  formData.append('reportType', initalContent.report_type);
  formData.append('username', initalContent.username);
  formData.append('password', initalContent.password);
  formData.append('last4ofsocial', initalContent.ssn);
  formData.append('env', "member");
  let response = await axios.post('form/GetReportUploaderDataDisputeForm', formData);
  if (response.status === 200) {
    if (response.data.error !== 2) {
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

export const getRounds = createAsyncThunk('reports/getRounds', async client_id => {
  let formData = new FormData();
  let accessToken = localStorage.getItem('accessToken');
  formData.append('Token', accessToken);
  formData.append('client_id', btoa(client_id));
  let response = await axios.post('form/getReportsList', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
      // return dataJson;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

const removeLocalStorage = () => {
  localStorage.removeItem('username');
  localStorage.removeItem('isAdmin');
  localStorage.removeItem('company_id');
  localStorage.removeItem('company_logo');
  localStorage.removeItem('accessToken');
};

const ReportSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    blankReportSubmitReport: state => {
      state.getReportSubmitReport = {};
    },
    blankGetReportData: state => {
      state.getReportData = {};
      state.getReportStatus = 'idle';
    },
    blankIdiqReport: state => {
      state.getIdiqReportData = {};
      state.getIdiqReportStatus = 'idle';
    },
    blankIdiqReportLogin: state => {
      state.getIdiqLoginReport = {};
      state.getIdiqLoginStatus = 'idle';
    },
    blankGetAllReportData: state => {
      state.getAllReportStatus = 'idle';
      // state.getAllReportData = {};
    },
    setReportUploaded: (state, action) => {
      state.isReportUploaded = action.payload;
    },
    blankGetRounds: state => {
      state.getRoundStatus = 'idle';
      state.getRoundData = {};
    },
  },
  extraReducers: builder => {
    builder.addCase(getReportContent.pending, state => {
      state.getReportStatus = 'loading';
    });
    builder.addCase(getReportContent.fulfilled, (state, action) => {
      state.getReportStatus = 'succeeded';
      state.error = '';
      state.getReportData = action.payload;
    });
    builder.addCase(getReportContent.rejected, (state, action) => {
      state.getReportStatus = 'falied';
      state.error = action.error.message;
      state.getReportData = {};
    });
    builder.addCase(submitReportContent.fulfilled, (state, action) => {
      state.getReportSubmitReport = action.payload;
    });
    builder.addCase(getAllReport.pending, state => {
      state.getAllReportStatus = 'loading';
    });
    builder.addCase(getAllReport.fulfilled, (state, action) => {
      state.getAllReportStatus = 'succeeded';
      state.error = '';
      state.getAllReportData = action.payload;
    });
    builder.addCase(getAllReport.rejected, (state, action) => {
      state.getAllReportStatus = 'falied';
      state.error = action.error.message;
      state.getAllReportData = {};
    });
    builder.addCase(getIdiqReport.pending, state => {
      state.getIdiqReportStatus = 'loading';
    });
    builder.addCase(getIdiqReport.fulfilled, (state, action) => {
      state.getIdiqReportStatus = 'succeeded';
      state.error = '';
      state.getIdiqReportData = action.payload;
    });
    builder.addCase(getIdiqReport.rejected, (state, action) => {
      state.getIdiqReportStatus = 'falied';
      state.error = action.error.message;
      state.getIdiqReportData = {};
    });
    builder.addCase(getIdiqReportLogin.pending, state => {
      state.getIdiqLoginStatus = 'loading';
    });
    builder.addCase(getIdiqReportLogin.fulfilled, (state, action) => {
      state.getIdiqLoginStatus = 'succeeded';
      state.error = '';
      state.getIdiqLoginReport = action.payload;
    });
    builder.addCase(getIdiqReportLogin.rejected, (state, action) => {
      state.getIdiqLoginStatus = 'falied';
      state.error = action.error.message;
      state.getIdiqLoginReport = {};
    });
    builder.addCase(getRounds.pending, state => {
      state.getRoundStatus = 'loading';
    });
    builder.addCase(getRounds.fulfilled, (state, action) => {
      state.getRoundStatus = 'succeeded';
      state.error = '';
      state.getRoundData = action.payload;
    });
    builder.addCase(getRounds.rejected, (state, action) => {
      state.getRoundStatus = 'falied';
      state.error = action.error.message;
      state.getRoundData = {};
    });
  },
});
export const { blankReportSubmitReport, blankGetReportData, blankIdiqReport, blankGetAllReportData, setReportUploaded, blankGetRounds, blankIdiqReportLogin } = ReportSlice.actions;

export default ReportSlice.reducer;
